import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as DocumentsActions from './documents.action';
import { Channels } from 'src/app/store/channels';
import { GeneralSignalRResponse } from '../../signal-r/general-signal-r-response';
import { SignalRService } from '../../signal-r/signal-r.service';
import { SignalRAction } from '../../signal-r/signalr-enums';

@Injectable({
  providedIn: 'root'
})
export class DocumentsStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new DocumentsActions.DocumentsRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.DOCUMENTS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new DocumentsActions.DocumentsCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new DocumentsActions.DocumentsUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new DocumentsActions.DocumentsDelete(data.obj));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new DocumentsActions.DocumentsRefresh());
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new DocumentsActions.DocumentsRequestRefresh(data.obj));
          break;
      }
    });
  }
}
